import { defineMessages } from 'utils/intl';

export default defineMessages({
  clear: 'Wyczyść ({length})',
  filters: 'Filtry:',
});
